import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { FaqServiceSupportTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<FaqServiceSupportTheme>;
const css = baseCss as ThemedCssFunction<FaqServiceSupportTheme>;

export const FaqServiceSupport = styled.div`
  width: 100%;
  height: 100%;
`;
